"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon, Monitor } from "lucide-react";
import { useI18n } from "@/components/i18n-provider";

// Три состояния по кругу: «как в системе» → светлая → тёмная → «как в системе».
// По умолчанию портал следует теме браузера/устройства; ручной выбор её
// перекрывает, и вернуться к системной можно этой же кнопкой.
const ORDER = ["system", "light", "dark"] as const;
type Mode = (typeof ORDER)[number];

export function ThemeToggle() {
  const { dict } = useI18n();
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const mode: Mode = ORDER.includes(theme as Mode) ? (theme as Mode) : "system";
  const labels: Record<Mode, string> = {
    system: dict.nav.themeSystem,
    light: dict.nav.themeLight,
    dark: dict.nav.themeDark,
  };
  const Icon = mode === "system" ? Monitor : mode === "dark" ? Sun : Moon;
  // ВАЖНО: до монтирования разметка обязана совпадать с серверной. На сервере
  // темы нет, а на клиенте next-themes читает localStorage уже в первом
  // рендере — поэтому ни один атрибут не должен зависеть от `mode`, пока
  // `mounted` не выставлен. Иначе React ругается на несовпадение гидратации.
  const label = mounted ? labels[mode] : labels.system;

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => setTheme(ORDER[(ORDER.indexOf(mode) + 1) % ORDER.length])}
      className="flex size-9 items-center justify-center rounded-lg border bg-background text-muted-foreground shadow-sm transition-colors hover:text-foreground"
    >
      {/* До монтирования тема неизвестна — держим место, чтобы не мигало. */}
      {mounted ? <Icon className="size-4" /> : <Monitor className="size-4 opacity-0" />}
    </button>
  );
}
